import React from "react";

import {
  // eslint-disable-next-line no-restricted-imports
  ExpandableRow as ExpandableRowDS,
  ExpandableRowProps
} from "@packages/ds";
import { useIntl } from "react-intl";

/**
 * SettingLine component - wrapper around ExpandableRow with i18n support
 */
const SettingLine = ({
  addNewTitle = "",
  openText,
  ...props
}: ExpandableRowProps) => {
  const intl = useIntl();

  // Handle i18n for texts
  const localizedAddNewTitle =
    addNewTitle || intl.formatMessage({ id: "add", defaultMessage: "Add" });

  const localizedOpenText =
    openText ?? intl.formatMessage({ id: "view", defaultMessage: "View" });

  return (
    <ExpandableRowDS
      addNewTitle={localizedAddNewTitle}
      openText={localizedOpenText}
      {...props}
    />
  );
};

export default SettingLine;
